export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            'textures/environmentMap/px.jpg',
            'textures/environmentMap/nx.jpg',
            'textures/environmentMap/py.jpg',
            'textures/environmentMap/ny.jpg',
            'textures/environmentMap/pz.jpg',
            'textures/environmentMap/nz.jpg'
        ]
    },
    {
        name: 'grassColorTexture',
        type: 'texture',
        path: 'textures/dirt/color.jpg'
    },
    {
        name: 'grassNormalTexture',
        type: 'texture',
        path: 'textures/dirt/normal.jpg'
    },
    {
        name: 'portalColorTexture',
        type: 'texture',
        path: 'textures/portal/portalColor.png'
    },
    {
        name: 'buildingModel',
        type: 'gltfModel',
        path: 'models/building/building.gltf'
    },
    {
        name: 'portalModel',
        type: 'gltfModel',
        path: 'models/portal/portal.glb'
    },
    {
        name: 'portalModelCone',
        type: 'gltfModel',
        path: 'models/Cone/CONE-2k.glb'
    },
    {
        name: 'buildingAModel',
        type: 'gltfModel',
        path: 'models/building/buildingA.glb'
    },
    {
        name: 'buildingBModel',
        type: 'gltfModel',
        path: 'models/building/buildingB.glb'
    },
    {
        name: 'buildingCModel',
        type: 'gltfModel',
        path: 'models/building/buildingC.glb'
    },
    {
        name: 'buildingDModel',
        type: 'gltfModel',
        path: 'models/building/buildingD.glb'
    },
    {
        name: 'buildingEModel',
        type: 'gltfModel',
        path: 'models/building/buildingE.glb'
    },
    {
        name: 'buildingFModel',
        type: 'gltfModel',
        path: 'models/building/buildingF.glb'
    },
    {
        name: 'buildingGModel',
        type: 'gltfModel',
        path: 'models/building/buildingG.glb'
    },
    {
        name: 'buildingHModel',
        type: 'gltfModel',
        path: 'models/building/buildingH.glb'
    },
    {
        name: 'axolotlModel',
        type: 'gltfModel',
        path: 'models/axolotl/axolotl-colored.glb'
    },
    {
        name: 'carModelWhite',
        type: 'gltfModel',
        path: 'models/car/car-custom-white.glb'
    },
    {
        name: 'carModelBlue',
        type: 'gltfModel',
        path: 'models/car/car-custom-blue.glb'
    },
    {
        name: 'carModelOrange',
        type: 'gltfModel',
        path: 'models/car/car-custom-orange.glb'
    },
    {
        name: 'carModelPurple',
        type: 'gltfModel',
        path: 'models/car/car-custom-purple.glb'
    },
    {
        name: 'carModelRed',
        type: 'gltfModel',
        path: 'models/car/car-custom-red.glb'
    },
    {
        name: 'carModelGreen',
        type: 'gltfModel',
        path: 'models/car/car-custom-green.glb'
    },
    {
        name: 'helicopterModel',
        type: 'gltfModel',
        path: 'models/helicopter/Helicopter.glb'
    },
    {
        name: 'baseModel',
        type: 'gltfModel',
        path: 'models/base/base.glb'
    }
]